import { useEffect, useState } from 'react';

import { InteractionManager } from 'react-native';

/**
 * Returns true after React Native finishes pending interactions/animations,
 * so you can mount heavy UI without jank during transitions (e.g., opening modals).
 *
 * Example: const ready = useAfterInteractions(); return ready ? <Heavy /> : <Skeleton />
 */

export const useAfterInteractions = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const task = InteractionManager.runAfterInteractions(() => setReady(true));
    return () => task.cancel?.();
  }, []);
  return ready;
};
